import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

const ImageDragReorder = ({ urls, onSetUrls, onRemove }) => {
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(urls);
    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);

    onSetUrls(items);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="upload-list" direction="horizontal">
        {(provided) => (
          <AllUploadWrapper
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {urls.map((eachUrl, i) => (
              <Draggable
                key={eachUrl.viewUrl}
                draggableId={eachUrl.viewUrl}
                index={i}
              >
                {(provided) => (
                  <PreviewWrapper
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <PreviewImage
                      src={eachUrl.viewUrl}
                      width="38px"
                      height="38px"
                    />
                    <PreviewName>
                      {eachUrl.originalname} <br />
                    </PreviewName>

                    <PreviewDelete onClick={() => onRemove(eachUrl.viewUrl)}>
                      <img
                        src={require("../../assets/images/Delete.png")}
                        alt="delete"
                        width="24px"
                        height="24px"
                      />
                    </PreviewDelete>
                  </PreviewWrapper>
                )}
              </Draggable>
            ))}

            {provided.placeholder}
          </AllUploadWrapper>
        )}
      </Droppable>
    </DragDropContext>
  );
};

const AllUploadWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

const PreviewWrapper = styled.div`
  display: flex;
  margin: 0.4rem;
  position: relative;
  border: 1px solid ${Colors.appleGreen};
  border-radius: 0.25rem;
  background: ${Colors.whiteSmoke};
  // width: 180px;
  flex: 1 1 15rem;
`;

const PreviewImage = styled.img`
  padding: 0.5rem;
`;

const PreviewName = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 0.75rem;
  color: ${Colors.comet};
  margin-top: 1.25rem;
  margin-left: 0.5rem;
`;

const PreviewDelete = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 0.75rem;
  color: ${Colors.appleRed};
  position: absolute;
  right: 5%;
  margin-top: 1rem;
  cursor: pointer;
`;

export default ImageDragReorder;
